const iconNames: { [key: string]: string } = {
    speaker: 'ion-speakerphone',
    moon: 'ion-ios-moon',
    sun: 'ion-ios-sunny',
    chevronLeft: 'ion-chevron-left',
    chevronRight: 'ion-chevron-right',
};

export default iconNames;
